import script from "./SearchResultMaterialVariant.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultMaterialVariant.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultMaterialVariant.vue?vue&type=style&index=0&id=6e26853e&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e26853e"]])

export default __exports__